module.exports = __webpack_public_path__ + "static/media/boat-img-20.c20b8a17.jpg";